import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import EstateDetail from "@/pages/EstateDetail";
import Distribution from "@/pages/Distribution";
import Concierge from "@/pages/Concierge";
import Housekeeping from "@/pages/Housekeeping";
import Marketing from "@/pages/Marketing";
import "@/App.css";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  const [lang, setLang] = useState("en");
  return (
    <BrowserRouter>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Home lang={lang} setLang={setLang} />} />
        <Route path="/estates/:slug" element={<EstateDetail lang={lang} setLang={setLang} />} />
        <Route path="/distribution" element={<Distribution lang={lang} setLang={setLang} />} />
        <Route path="/concierge" element={<Concierge lang={lang} setLang={setLang} />} />
        <Route path="/housekeeping-maintenance" element={<Housekeeping lang={lang} setLang={setLang} />} />
        <Route path="/marketing" element={<Marketing lang={lang} setLang={setLang} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
